import { HttpHeaders } from "@angular/common/http";
import { AccessResult } from "src/app/Models/Access/access-result";
import { AppStateService } from "../AppState/app-state.service";
import { ConstService } from "../Const/const.service";

export class AccessService {

  public checkAccessModule: boolean = false;
  
  constructor(private appStateService: AppStateService) { }

  /**
   * @description Permite validar si un usuario ERP posee acceso al Portal de Proveedores
   * @returns {boolean}
   */
  public GetAccessModule(): Promise<AccessResult> 
  {
    return new Promise((resolve, reject) =>
    {
      let url = `${ConstService.URLApi}/Access`;
      let headers = new HttpHeaders()
                        .set('Authorization', `Bearer ${this.appStateService.Access_Token}`);
  
      this.appStateService.http.get<AccessResult>(url, { headers })
          .subscribe(res =>
          {
            resolve(res);
          },
          err =>{
            reject(err);
          })
    })
  }
}
